import { attr } from '@ember-data/model';
import UserDocumentTemplateConfigurableModel from 'garaje/models/user-document-template-configurable';

export default class AbstractFlowModel extends UserDocumentTemplateConfigurableModel {
  @attr('string', { defaultValue: '' }) declare name: string;
}
